<template>
  <div>
    <span>
      <button
        v-on:click="cariEkstre()"
        style="border: none; background: none; margin-right: 5px"
      >
        <box-icon
          style="float: right"
          name="search-alt-2"
          animation="tada-hover"
          color="#7367F0"
          class="text-body align-middle mr-25"
        ></box-icon>
      </button>
    </span>
    <FinansalRaporDetay ref="finansalraporref" />
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import "boxicons";
import FinansalRaporDetay from "./FinansalRaporDetay.vue";

import router from "../../../../router";

import { BDropdown, BDropdownItem } from "bootstrap-vue";
export default {
  components: {
    BDropdown,
    BDropdownItem,
    FinansalRaporDetay,
  },
  methods: {
    cariEkstre() {
      if (typeof this.params.data.BAKIYE == "undefined") {
        this.$refs.finansalraporref.rpAcikFaturalarDetay(
        this.params.data.ACTID,
        this.params.data.ACTNAME,
        this.params.data.TUTAR
      );
      } else {
        this.$refs.finansalraporref.rpAcikFaturalarDetay(
          this.params.data.ACTID,
          this.params.data.ACTNAME,
          this.params.data.BAKIYE
        );
      }

    },
  },
};
</script>